/**
 * IndexSlider - Standalone index slider control
 *
 * A reusable index slider component that can be placed in any layout slot.
 * Handles media index navigation with slider UI.
 */

import SliderInput from '@wandb/weave/common/components/elements/SliderInput';
import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Popup} from 'semantic-ui-react';

export type IndexSliderProps = {
  min?: number;
  max: number;
  current: number;
  label?: string;
  onChange: (value: number) => void;
  'data-test'?: string;
};

/**
 * Renders an index slider control with label and tooltip.
 *
 * @param props - IndexSliderProps
 * @returns React element
 */
export const IndexSlider: React.FC<IndexSliderProps> = ({
  min = 0,
  max,
  current,
  label = 'Index',
  onChange,
  'data-test': dataTest = 'index-slider',
}) => {
  return (
    <div className="control-popup__control-slider" data-test={dataTest}>
      <Popup
        trigger={<label htmlFor="panelMediaBrowserIndex">{label}</label>}
        popperModifiers={{
          preventOverflow: {
            // prevent popper from erroneously constraining the popup to the
            // table header
            boundariesElement: 'viewport',
          },
        }}
        content={
          'This is the index in the array of examples in your wandb.log call'
        }
      />
      <SliderInput
        // @ts-expect-error - Weave component needs fixing
        id="panelMediaBrowserIndex"
        min={min}
        max={max}
        minLabel={min.toString()}
        maxLabel={max.toString()}
        step={1}
        value={current}
        hasInput
        onChange={onChange}
        showTicks={false}
      />
    </div>
  );
};
